module.exports = __webpack_public_path__ + "static/media/recover-bg.f2ba9c34.jpg";